// extracted by mini-css-extract-plugin
export default {"button":"app-locations-EventLocationSingle-EventLocationSingle-module__FOU86cMgVyM3gKeCmssM"};